import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NavigationBar from "@/components/NavigationBar";
import Footer from "@/components/Footer";
import FAQSection from "@/components/FAQSection";

const HowItWorksPage = ({ user }) => {
  // Scroll to top when component loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FFFBF5' }}>
      {/* Navigation Bar */}
      <NavigationBar user={user} />

      {/* Header */}
      <div className="bg-black text-white py-20 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-4 uppercase tracking-wide">How Does It Work</h1>
          <p className="text-lg text-white/90">Frequently Asked Questions</p>
        </div>
      </div>

      {/* FAQ Content - Dynamic from Admin Portal */}
      <FAQSection 
        category="how-does-it-work" 
        title="Frequently Asked Questions" 
      />

      {/* CTA Section */}
      <div className="bg-black text-white py-16 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6 uppercase tracking-wide">Ready to Get Started?</h2>
          <p className="text-lg mb-8 text-white/90">Join The Haute Circle and experience luxury through fractional ownership</p>
          <Link to="/register-interest">
            <button className="bg-white text-gold hover:bg-white/90 px-12 py-4 text-lg uppercase tracking-wider font-semibold rounded shadow-lg">
              Register Your Interest
            </button>
          </Link>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HowItWorksPage;
